/**
 * Returns the date with ordinal, i.e 10th, 2nd, 3rd
 * @param number {number} - The date, i.e 31, 10.
 * @returns {string} - with ordinal, i.e 10th.
 */
export const getNumberWithOrdinal = (number) => {
  if (number > 3 && number < 21) return `${number}th`
  let ordinal
  switch (number % 10) {
    case 1:
      ordinal = 'st'
      break
    case 2:
      ordinal = 'nd'
      break
    case 3:
      ordinal = 'rd'
      break
    default:
      ordinal = 'th'
      break
  }
  return `${number}${ordinal}`
}
